import { type RequestPayload, router } from "@inertiajs/core";
import { AdminForm } from "../../../components/admin/AdminForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { admins_path } from "../../../routes";

export default function AdminCreate() {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(admins_path), values);

  return (
    <ContentShell title="Neuer Admin" onBack={() => router.get(pathWithYearContext(admins_path))}>
      <AdminForm onSubmit={onSubmit} submitButtonLabel="Erstellen" />
    </ContentShell>
  );
}
